/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespTradeOnApprovalCoachmarkLoader_item$ref: FragmentReference;
export type PdpRespTradeOnApprovalCoachmarkLoader_item = {|
  +serviceId: ?string,
  +$refType: PdpRespTradeOnApprovalCoachmarkLoader_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespTradeOnApprovalCoachmarkLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '0d7fad06a94145eca46080caf0dc776d';
module.exports = node;
